import { Component, Input, OnDestroy, OnInit, signal } from '@angular/core';
import {AppStateService} from "src/app/core-module/services/app-state.service";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import { BehaviorSubject, catchError, forkJoin, map, Observable, of, shareReplay, Subject, Subscription, takeUntil, tap } from 'rxjs';

import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {ErrorComponent} from "src/app/error/error.component";
import {
  processCorruptedSpecialFeatures, setResultFeatures
} from "../shared-module/components/corruptfeatures/corrupt-features-processing";
import {
  ConfigureDeviceModalInputComponent
} from '../configure-device-modal-input/configure-device-modal-input.component';
import {environment} from "../../environments/environment";

import {OwpPasswordComponent} from "src/app/owp-password/owp-password.component";
import {FEATURE_NORMALIZATION, FEATURE_PATTERNS} from '../shared-module/constants/supported-features-constant';
import { AvailableFeaturesStateService } from "../core-module/services/state/available-features-state.service";
import { CorruptFeaturesService } from "../core-module/services/state/corrupt-features.service";
import { DeviceConfigStateService } from "../core-module/services/state/device-config-state.service";
import { FeatureUtilsService } from "../core-module/services/state/feature-utils.service";
import { MtpExtrasStateService } from "../core-module/services/state/mtp-extras-state.service";
import { MultiOneHttpClient } from "../core-module/services/state/multi-one-http-client.service";
import { OwpStateService } from "../core-module/services/state/owp-state.service";
import { UiSignalsStateService } from "../core-module/services/state/ui-signals-state.service";
import { DEVICE_SEARCH_ENDPOINT } from "../shared-module/constants/configure-device-modal.constants";
import {
  COMMON_MEMORY_BANKS,
  CORRUPT_BIT_URL,
  DALI253_MEMORY_BANK,
  DEVICE_INFO_REFRESH_URL,
  FORMATTED_MEMORY_BANK_URL,
  IMPORT_PAYLOAD_URL,
  IMPORT_PAYLOAD_URL_NE,
  MEMORY_BANK_URL,
  PAYLOAD_URL,
  READER_BASE_URL,
  READER_DATA_URL,
  READER_LIST_URL,
  READER_START_URL,
  WRITING_IN_DEVICE_URL,
} from "../shared-module/constants/reader-device.constants";
import {
  ReadDefaultValuesPopupComponent
} from "../shared-module/components/read-default-values-popup/read-default-values-popup.component";

const READER_NOT_CONNECTED_MSG = "Reader not connected";
const INCORRECT_DEVICES_FOUND_MSG = "Incorrect number of devices found";

@Component({
  standalone: false,
  selector: "app-read-device-multi-driver",
  templateUrl: "./read-device-multi-driver.component.html",
  styleUrls: ["./read-device-multi-driver.component.scss"],
})
export class ReadDeviceMultiDriverComponent implements OnInit, OnDestroy {
  @Input() public newPayLoadValues;
  @Input() public isRetry:boolean=false;
  readDevice: LegacyAny;
  deviceNfcId: LegacyAny;
  private readonly multipleDeviceErrorSignal = signal(false);
  private readonly writingDevicesHeadingSignal = signal(true);
  invalidFeatureData: LegacyAny = [];
  allCorruptedFeaturesSet = new Set<string>();
  private readonly retryOwpPasswordSignal = signal(false);
  public failedOwpNfcIds: string[] = [];
  private readonly readerPresenceSignal = signal(false);
  private readonly wrongReaderSignal = signal(false);
  readingStatus;
  private readonly loadingSignal = signal(false);
  private readonly nextClickedSignal = signal(true);
  private readonly changedDEVICESignal = signal(false);
  private readonly showRetryOwpButtonSignal = signal(false);
  allCorruptedFeatureNames = new Set<string>();
  private readonly readconfiguredDevicesSignal = signal(false);
  private readonly differentDeviceErrorSignal = signal(false);
  readerData;
  lineSwitchSupported: boolean;
  ampDimSupported: boolean;
  codedMainsSupported: boolean;
  dynadimmerSupported: boolean;
  private readonly allCorruptFeatureNotSelectedSignal = signal(false);
  private readonly hideStatusSignal = signal(false);
  private readonly customerLoaderSignal = signal(false);
  private readonly interdependencyObjSetIdentifiedSignal = signal(false);
  private readonly isProductionInfoAvailableSignal = signal(false);
  private readonly customerLoaderAfterSignal = signal(false);
  private readonly noReaderSignal = signal(false);
  isOwpObj: boolean;
  private readonly specialErrorNoDatabaseSignal = signal(false);
  baseLinkUrl = READER_BASE_URL;
  readerStartUrl = READER_START_URL;
  readerListUrl = READER_LIST_URL;
  readreDataUrl = READER_DATA_URL;
  readerName: LegacyAny;
  listReader: LegacyAny = [];
  errorMessage: LegacyAny;
  readerLength: LegacyAny = [];
  deviceInfoUrl = DEVICE_INFO_REFRESH_URL;
  memoryBankUrl =
    MEMORY_BANK_URL;
  envScehmaLIstApi: LegacyAny;
  corruptBitUrl =
    CORRUPT_BIT_URL;
  writingInDeviceURL =
    WRITING_IN_DEVICE_URL;
  listOfBank: LegacyAny;
  unsubscribe = new Subject<void>();
  allFeatures: LegacyAny;
  feature12NcName: LegacyAny = [];
  readerBaseUrl: string;
  readerDeviceData: LegacyAny;
  featureWithId: LegacyAny;
  productionDate: LegacyAny;
  productionBatchId: LegacyAny;
  sku: LegacyAny;
  nonCorrupt = [];
  corrupt = [];
  payLoadUrl = PAYLOAD_URL;
  importPayLoadUrl =
    IMPORT_PAYLOAD_URL;
  importPayLoadUrlNE =
    IMPORT_PAYLOAD_URL_NE;
  startConfiguration;
  specificFeaturePayLoad;
  url: LegacyAny;
  deviceInformationObj: {};
  bankIdByIndex: LegacyAny;
  newDeviceObj;
  envHostName;
  apiListResponse: LegacyAny[] = [];
  mem: LegacyAny = [];
  softwareVersionSchema: LegacyAny;
  preFetchedPluginData: LegacyAny = null;
  luminSoftwareVersionSchema: LegacyAny;
  everySchemaofDevice: LegacyAny;
  alominBankId: boolean;
  isALoMinObj: boolean;
  private readonly isWritingRetryCheckSignal = signal(false);
  payLoadResp: LegacyAny;
  selectedReader
  subscription: Subscription;
  removeSuccessText: boolean;
  writingDevicesContainer: boolean;
  writingURL: LegacyAny;
  private readonly removeWritingHeaderSignal = signal(true);
  writingURLViaPlugin =
    IMPORT_PAYLOAD_URL;
  writingURLViaPluginNE =
    IMPORT_PAYLOAD_URL_NE;
  formattedMemoryBankUrl =
    FORMATTED_MEMORY_BANK_URL;
  isAocMinObj: boolean;
  isLumMinSixObj: boolean;
  specificMemoryBanksList = [...COMMON_MEMORY_BANKS, DALI253_MEMORY_BANK];
  regions: string[];
  searchName: LegacyAny[];
  apiList: LegacyAny = [];
  deviceInfo: LegacyAny;
  fullDeviceList = DEVICE_SEARCH_ENDPOINT;
  envDeviceListURL: string;
  writingDevice: LegacyAny;
  corruptBits: LegacyAny;
  isNormalFlow: LegacyAny;
  dtlSoftwareVersionSchema: LegacyAny;
  startConfigurationURL: LegacyAny[];
  allMemoryBanks: LegacyAny = { memoryBankId: "All" };
  envAloschemaDetails: LegacyAny;
  configurationData: LegacyAny;
  latestDeviceVersion: LegacyAny = [];
  latestDvValue: LegacyAny;
  private readonly retryButtonSignal = signal(false);
  private readonly retryClickedSignal = signal(false);
  mtpSoftwareVersionSchema: LegacyAny;
  dimminginterfaceSoftwareVersionSchema: LegacyAny;
  cloSoftwareVersionSchema: LegacyAny;
  aloSoftwareVersionSchema: LegacyAny;
  aocSoftwareVersionSchema: LegacyAny;
  touchdimSoftwareVersionSchema: LegacyAny;
  corridorSoftwareVersionSchema: LegacyAny;
  ztvSoftwareVersionSchema: LegacyAny;
  ampdimSoftwareVersionSchema: LegacyAny;
  astSoftwareVersionSchema: LegacyAny;
  cloliteSoftwareVersionSchema: LegacyAny;
  dynadimSoftwareVersionSchema: LegacyAny;
  dcemergencySoftwareVersionSchema: LegacyAny;
  lineswitchSoftwareVersionSchema: LegacyAny;
  codedmainsSoftwareVersionSchema: LegacyAny;
  private readonly continueReadSignal = signal(false);
  errorCodedDC = [
    "206-Error occurred due to unsupported request! Please try again. If the issue persists contact Signify",
    "304-Error occurred due to unsupported request! Please try again. If the issue persists contact Signify",
    "400-Error occurred due to unsupported request! Please try again. If the issue persists contact Signify",
    "400.1-Error occurred due to unsupported request! Please try again. If the issue persists contact Signify",
    "400.2-Error occurred due to unsupported request! Please try again. If the issue persists contact Signify",
    "400.3-Error occurred due to unsupported request! Please try again. If the issue persists contact Signify",
    "400.4-Error occurred due to unsupported request! Please try again. If the issue persists contact Signify",
    "400.5-Error occurred due to unsupported request! Please try again. If the issue persists contact Signify",
    "400.6-Error occurred due to unsupported request! Please try again. If the issue persists contact Signify",
    "400.7-Error occurred due to unsupported request! Please try again. If the issue persists contact Signify",
    "400.8-Error occurred due to unsupported request! Please try again. If the issue persists contact Signify",
    "400.9-Device not found! Please check the device and try again",
    "404.1-Please check the reader and try again",
    "404.2-No device found! \n Please check the device(s) and try again",
    "404.3-Number of devices found do not match the given quantity! \n Please adjust the quantity of drivers",
    "405-Error occurred due to unsupported request! Please try again. If the issue persists contact Signify",
    "412.1-Please check the reader and try again",
    "412.2-Device not found! Please check the device and try again",
    "500-Error occurred due to unsupported request! Please try again. If the issue persists contact Signify",
    "1203_1-Error occurred due to unsupported request! Please try again. If the issue persists contact Signify",
  ];
  private readonly showExtraPopUpSignal = signal(true);
  private readonly showDeviceIDReadDCSignal = signal(false);
  private readonly deviceCNtMatchedSignal = signal(false);
  private readonly configConnectedDevicesSignal = signal(false);
  private readonly showNextSuccessWriteBtnSignal = signal(false);
  userBoxSizeValue: LegacyAny=24;
  private readonly incorrectBoxSizeSignal = signal(false);
  actualDevicesCnt: number = 0;
  private readonly owpProtectedMultiDevicesSignal = signal(false);
  private readonly deviceNotMatchingSignal = signal(false);
  deviceNfcIdsList:string[]=[];
  pathVal:string;
  // readerUrl: LegacyAny;
  // isTestCase: boolean=true;
  public initialCount: LegacyAny = 0;
  public outOfCount = 24;
  getShowNextMultiSuccessBtnSub: Subscription;

  get multipleDeviceError(): boolean { return this.multipleDeviceErrorSignal(); }
  set multipleDeviceError(value: boolean) { this.multipleDeviceErrorSignal.set(!!value); }

  get writingDevicesHeading(): boolean { return this.writingDevicesHeadingSignal(); }
  set writingDevicesHeading(value: boolean) { this.writingDevicesHeadingSignal.set(!!value); }

  get retryOwpPassword(): boolean { return this.retryOwpPasswordSignal(); }
  set retryOwpPassword(value: boolean) { this.retryOwpPasswordSignal.set(!!value); }

  get readerPresence(): boolean { return this.readerPresenceSignal(); }
  set readerPresence(value: boolean) { this.readerPresenceSignal.set(!!value); }

  get wrongReader(): boolean { return this.wrongReaderSignal(); }
  set wrongReader(value: boolean) { this.wrongReaderSignal.set(!!value); }

  get loading(): boolean { return this.loadingSignal(); }
  set loading(value: boolean) { this.loadingSignal.set(!!value); }

  get nextClicked(): boolean { return this.nextClickedSignal(); }
  set nextClicked(value: boolean) { this.nextClickedSignal.set(!!value); }

  get changedDEVICE(): boolean { return this.changedDEVICESignal(); }
  set changedDEVICE(value: boolean) { this.changedDEVICESignal.set(!!value); }

  get showRetryOwpButton(): boolean { return this.showRetryOwpButtonSignal(); }
  set showRetryOwpButton(value: boolean) { this.showRetryOwpButtonSignal.set(!!value); }

  get readconfiguredDevices(): boolean { return this.readconfiguredDevicesSignal(); }
  set readconfiguredDevices(value: boolean) { this.readconfiguredDevicesSignal.set(!!value); }

  get differentDeviceError(): boolean { return this.differentDeviceErrorSignal(); }
  set differentDeviceError(value: boolean) { this.differentDeviceErrorSignal.set(!!value); }

  get allCorruptFeatureNotSelected(): boolean { return this.allCorruptFeatureNotSelectedSignal(); }
  set allCorruptFeatureNotSelected(value: boolean) { this.allCorruptFeatureNotSelectedSignal.set(!!value); }

  get hideStatus(): boolean { return this.hideStatusSignal(); }
  set hideStatus(value: boolean) { this.hideStatusSignal.set(!!value); }

  get customerLoader(): boolean { return this.customerLoaderSignal(); }
  set customerLoader(value: boolean) { this.customerLoaderSignal.set(!!value); }

  get interdependencyObjSetIdentified(): boolean { return this.interdependencyObjSetIdentifiedSignal(); }
  set interdependencyObjSetIdentified(value: boolean) { this.interdependencyObjSetIdentifiedSignal.set(!!value); }

  get isProductionInfoAvailable(): boolean { return this.isProductionInfoAvailableSignal(); }
  set isProductionInfoAvailable(value: boolean) { this.isProductionInfoAvailableSignal.set(!!value); }

  get customerLoaderAfter(): boolean { return this.customerLoaderAfterSignal(); }
  set customerLoaderAfter(value: boolean) { this.customerLoaderAfterSignal.set(!!value); }

  get noReader(): boolean { return this.noReaderSignal(); }
  set noReader(value: boolean) { this.noReaderSignal.set(!!value); }

  get specialErrorNoDatabase(): boolean { return this.specialErrorNoDatabaseSignal(); }
  set specialErrorNoDatabase(value: boolean) { this.specialErrorNoDatabaseSignal.set(!!value); }

  get isWritingRetryCheck(): boolean { return this.isWritingRetryCheckSignal(); }
  set isWritingRetryCheck(value: boolean) { this.isWritingRetryCheckSignal.set(!!value); }

  get removeWritingHeader(): boolean { return this.removeWritingHeaderSignal(); }
  set removeWritingHeader(value: boolean) { this.removeWritingHeaderSignal.set(!!value); }

  get retryButton(): boolean { return this.retryButtonSignal(); }
  set retryButton(value: boolean) { this.retryButtonSignal.set(!!value); }

  get retryClicked(): boolean { return this.retryClickedSignal(); }
  set retryClicked(value: boolean) { this.retryClickedSignal.set(!!value); }

  get continueRead(): boolean { return this.continueReadSignal(); }
  set continueRead(value: boolean) { this.continueReadSignal.set(!!value); }

  get showExtraPopUp(): boolean { return this.showExtraPopUpSignal(); }
  set showExtraPopUp(value: boolean) { this.showExtraPopUpSignal.set(!!value); }

  get showDeviceIDReadDC(): boolean { return this.showDeviceIDReadDCSignal(); }
  set showDeviceIDReadDC(value: boolean) { this.showDeviceIDReadDCSignal.set(!!value); }

  get deviceCNtMatched(): boolean { return this.deviceCNtMatchedSignal(); }
  set deviceCNtMatched(value: boolean) { this.deviceCNtMatchedSignal.set(!!value); }

  get configConnectedDevices(): boolean { return this.configConnectedDevicesSignal(); }
  set configConnectedDevices(value: boolean) { this.configConnectedDevicesSignal.set(!!value); }

  get showNextSuccessWriteBtn(): boolean { return this.showNextSuccessWriteBtnSignal(); }
  set showNextSuccessWriteBtn(value: boolean) { this.showNextSuccessWriteBtnSignal.set(!!value); }

  get incorrectBoxSize(): boolean { return this.incorrectBoxSizeSignal(); }
  set incorrectBoxSize(value: boolean) { this.incorrectBoxSizeSignal.set(!!value); }

  get owpProtectedMultiDevices(): boolean { return this.owpProtectedMultiDevicesSignal(); }
  set owpProtectedMultiDevices(value: boolean) { this.owpProtectedMultiDevicesSignal.set(!!value); }

  get deviceNotMatching(): boolean { return this.deviceNotMatchingSignal(); }
  set deviceNotMatching(value: boolean) { this.deviceNotMatchingSignal.set(!!value); }
  owpProtectedDevices: number = 0;
  totalMatchedDevices: number = 0;
  isError: boolean = false;
  isDeviceConnected: boolean = true;
  corruptedDevices: boolean = false;
  corruptedDevicesCount: number = 0;
  isShowCancelBtn: boolean = true;
  OWP_Error = "Some features are OWP protected \n Please provide the correct OEM Write Protection password which currently locks the driver";
  owpError: boolean = false;
  public service: LegacyAny;

  constructor(

    public activemodal: NgbActiveModal,
    private readonly modalService: NgbModal,
    private readonly http: HttpClient,
    public route: Router,
    private readonly appState: AppStateService,
    private readonly utils: FeatureUtilsService,
    private readonly availFeat: AvailableFeaturesStateService,
    private readonly mtpExtras: MtpExtrasStateService,
    private readonly uiSignals: UiSignalsStateService,
    private readonly corruptFeatures: CorruptFeaturesService,
    private readonly deviceConfig: DeviceConfigStateService,
    private readonly owp: OwpStateService,
    private readonly httpClient: MultiOneHttpClient
  ) {
    this.service = {
      sendMultiFeatures: (data: LegacyAny) => this.availFeat.sendMultiFeatures(data),
      getSelectedFeaturesArray: () => this.uiSignals.getSelectedFeaturesArray(),
      apiCall: (method: string, url: LegacyAny, body?: LegacyAny, httpOptions?: LegacyAny) => {
        const client: LegacyAny = this.httpClient as LegacyAny;
        if (client && typeof client.apiCall === "function") {
          return client.apiCall(method, url, body, httpOptions);
        }
        return of(undefined);
      },
      putApi: (method: string, url: LegacyAny, body?: LegacyAny, httpOptions?: LegacyAny) => {
        const client: LegacyAny = this.httpClient as LegacyAny;
        if (client && typeof client.putApi === "function") {
          return client.putApi(method, url, body, httpOptions);
        }
        return of(undefined);
      },
      sendOwpPasswordSelected: (isSelected: boolean) =>
        this.owp.sendOwpPasswordSelected(isSelected),
      sendOwpAccessPwd: (values: LegacyAny) => this.owp.sendOwpAccessPwd(values)
    };

    Object.defineProperty(this.service, "listOfAvailableFeatures", {
      get: () => this.availFeat.listOfAvailableFeatures,
      set: (features: LegacyAny) => {
        this.availFeat.listOfAvailableFeatures = features;
      }
    });
  }

  private apiCall(method: string, url: LegacyAny, body?: LegacyAny, httpOptions?: LegacyAny): LegacyAny {
    const client: LegacyAny = this.httpClient as LegacyAny;
    if (client && typeof client.apiCall === "function") {
      return client.apiCall(method, url, body, httpOptions);
    }
    if (this.service && typeof this.service.apiCall === "function") {
      return this.service.apiCall(method, url, body, httpOptions);
    }
    return of(undefined);
  }

  private putApi(method: string, url: LegacyAny, body?: LegacyAny, httpOptions?: LegacyAny): LegacyAny {
    const client: LegacyAny = this.httpClient as LegacyAny;
    if (client && typeof client.putApi === "function") {
      return client.putApi(method, url, body, httpOptions);
    }
    if (this.service && typeof this.service.putApi === "function") {
      return this.service.putApi(method, url, body, httpOptions);
    }
    return of(undefined);
  }

  private sendMultiFeatures(data: LegacyAny): void {
    if (this.availFeat && typeof (this.availFeat as LegacyAny).sendMultiFeatures === "function") {
      this.availFeat.sendMultiFeatures(data);
    }
    if (this.service && typeof this.service.sendMultiFeatures === "function") {
      this.service.sendMultiFeatures(data);
    }
    const client: LegacyAny = this.httpClient as LegacyAny;
    if (client && typeof client.sendMultiFeatures === "function") {
      client.sendMultiFeatures(data);
    }
  }

  ngOnInit() {

    this.nextClicked=true;
    const detectedReaderInfo = this.appState.getDetectedReaderInfo();
    if (detectedReaderInfo && detectedReaderInfo.selectedReader) {
      this.selectedReader = { ...detectedReaderInfo.selectedReader };
    }
    this.isShowCancelBtn = false;
    this.pathVal = this.utils.getImageUrl(window.location.hostname);

    this.readerBaseUrl = environment.multiOneAPIBaseReadUrl;
    this.showNextSuccessWriteBtn= false;
    /* this.service.getGeneratePlugInPutData.subscribe(pluginData=>{
      if(pluginData!="")
      this.mem = pluginData;
    }) */
    const pluginout = this.appState.getPluginOut();
    if (pluginout !== "") {
      this.mem = pluginout;
    }
    this.availFeat.getconfigData.subscribe((data) => {
      this.readDevice = data;
    });

    const availableFeatures = this.availFeat.listOfAvailableFeatures;

    this.getShowNextMultiSuccessBtnSub = this.mtpExtras.getShowNextMultiSuccessBtn.subscribe((data)=>{
      if(data){
       this.nextClicked=false;
        this.showNextSuccessWriteBtn = data;
        this.isShowCancelBtn = true;
        if(this.showNextSuccessWriteBtn===true){
          this.customerLoaderAfter=false;
        }
      }
    })

    this.mtpExtras.getUserBoxSizeValue.subscribe((data)=>{
      if(data){
        this.userBoxSizeValue = Number(data);
      }
    })
    this.uiSignals.getReaderInfo.subscribe((data) => {
      if (data) {
        this.readerData = data;
        this.hideStatus = true;
        this.readerName = data;

        // Start read flow immediately when reader info is available.
        this.dataInreader();
        /*  // setTimeout(() => {
         //   this.getListOfFeature();
         // }, 3000); */
      }
    });
    if (this.readDevice === "readDevice") {
      this.writingDevice = this.appState.getIsWriting();
      this.customerLoaderAfter = true;
      if (this.writingDevice) {
        this.readerName = this.appState.getReaderInfo();
        this.hideStatus = true;
        this.removeSuccessText = false;
        this.removeWritingHeader = true;
        this.writingDevicesContainer = true;
        this.isWritingRetryCheck = true;
        this.newReaderInfo();
      }
    }

    this.url = environment.multiOneAPIUrl;
    this.startConfigurationURL = this.url;

  }
  showDCError(errorMessage: LegacyAny, errorDescription: LegacyAny, show: boolean) {
    if (show) {
      const modalRef = this.modalService.open(ErrorComponent, {
        keyboard: false,
        centered: true,
        windowClass: "error-style, error-style1",
        backdrop: 'static'
      });
      modalRef.componentInstance.errorName = errorMessage;
      modalRef.componentInstance.errorDescription = errorDescription;
    }
    this.sendMultiFeatures(null);
  }

  /**
   * Shared UI-reset for the four "connected reader is incompatible" branches
   * in `newReaderInfo`. The caller sets `this.errorMessage` first and then
   * decides whether to `return`, continue with `newReader = true`, etc.
   * The two `customerLoaderAfter` assignments (true then false) are kept
   * for byte-compat with the original repeated blocks.
   */
  private applyIncompatibleReaderState(): void {
    this.wrongReader = true;
    this.readerData = null;
    this.customerLoaderAfter = true;
    this.noReader = false;
    this.readerPresence = true;
    this.showDCError("Not found", this.errorMessage, true);
    this.retryButton = true;
    this.hideStatus = true;
    this.customerLoaderAfter = false;
    this.customerLoader = false;
    this.isShowCancelBtn = true;
    this.appState.setReaderInfo(null);
  }

  /**
   * Shared error-status → user-message mapping used by many of the API
   * subscribe(error) callbacks. Iterates `this.errorCodedDC` (populated by
   * the config service with `"<status>-<message>"` entries) and, when a
   * match is found, sets `this.errorMessage`, rewrites `err.message`
   * ("Reader not connected") for 404.1/412.1, and shows the error dialog.
   *
   * @param err     the HttpErrorResponse-like object (fields: `status`, `message`)
   * @param setRetryInside when true, sets `this.retryButton = true` inside the
   *                       matching branch.
   */
  private handleErrorCodedError(err: LegacyAny, setRetryInside = false): void {
    this.errorCodedDC.forEach((errorCode) => {
      if (errorCode.includes(err.status)) {
        if (err.status === errorCode.split("-")[0]) {
          this.errorMessage = errorCode.split("-")[1];
          if (err.status === "404.1" || err.status === "412.1") {
            err.message = READER_NOT_CONNECTED_MSG;
          }
          this.showDCError(err.message, this.errorMessage, this.showExtraPopUp);
          if (setRetryInside) {
            this.retryButton = true;
          }
        }
      }
    });
  }

  /**
   * Multi-device variant of `handleErrorCodedError`: also handles the
   * `404.2` ("Error in finding devices") and `404.3` ("Incorrect number
   * of devices found") statuses that only surface in the multi-driver
   * flow, and unsets `noReader` / sets `readerPresence` for both.
   */
  private handleMultiDeviceErrorCodedError(err: LegacyAny, setRetryInside = false): void {
    this.errorCodedDC.forEach((errorCode) => {
      if (errorCode.includes(err.status)) {
        if (err.status === errorCode.split("-")[0]) {
          this.errorMessage = errorCode.split("-")[1];
          if (err.status === "404.2") {
            this.noReader = false;
            this.readerPresence = true;
            err.message = "Error in finding devices";
          } else if (err.status === "404.3") {
            this.noReader = false;
            this.readerPresence = true;
            err.message = INCORRECT_DEVICES_FOUND_MSG;
          } else if (err.status === "404.1" || err.status === "412.1") {
            err.message = READER_NOT_CONNECTED_MSG;
          }
          this.showDCError(err.message, this.errorMessage, this.showExtraPopUp);
          if (setRetryInside) {
            this.retryButton = true;
          }
        }
      }
    });
  }

  newReaderInfo() {
    this.nextClicked=true;
    this.customerLoaderAfter = true;
    this.getReaderList().subscribe(
        (data) => {
          this.readerData = data;
          this.appState.setReaderInfo(this.readerData);

          this.appState.setReaderDevices(data);

          const readers = this.appState.getDetectedReaderInfo();

          let newReader = false;

          const detectedReaderInfo = this.appState.getDetectedReaderInfo();

          if (
            (readers && readers["selectedReader"] == null ||

              (readers["selectedReader"].peripheralType !== "LCN9640"
                )
            ) ){
            this.errorMessage = "Connected reader does not support the box configuration! \n Please check the reader and try again";
            data = null;
            this.applyIncompatibleReaderState();
            newReader = true;
          }
          else if (
            Array.isArray(this.readerData) &&
            this.readerData.length > 0 &&
            this.readerData.every(r => ['LCN9620', 'LCN9630', 'LCN9610'].includes(r['peripheralType']))
          ) {
            this.errorMessage = "Connected reader does not support the box configuration! \n Please check the reader and try again";
            this.applyIncompatibleReaderState();
            return;
          }


          else if (
            (readers != null && readers["selectedReader"] != null &&
              !this.readerData.some(r => r['peripheralType'] === readers["selectedReader"]['peripheralType']))
          ) {
            if (readers["selectedReader"].peripheralType === "LCN9640") {
              this.errorMessage = "Connected reader is different from originally selected reader! \n Please connect the originally selected reader and try again";
            } else {
              this.errorMessage = "Connected reader does not support the box configuration! \n Please check the reader and try again";
            }
            data = null;
            this.applyIncompatibleReaderState();
            newReader = true;
          }

          else if (readers &&
            readers["selectedReader"] &&
            this.readerData.some(r => r['peripheralType'] === readers["selectedReader"]['peripheralType']))
          {

            const selectedReader = readers["selectedReader"];
            const connectedReader = this.readerData.find(r => r['peripheralId'] === selectedReader['peripheralId']) || this.readerData[0];

            if (connectedReader && selectedReader['peripheralId'] !== connectedReader['peripheralId']) {
              this.errorMessage = "Connected reader is different from originally selected reader! \n Please connect the originally selected reader and try again";
              if(connectedReader && connectedReader['peripheralType'] !== "LCN9640"){
                this.errorMessage="Connected reader does not support the box configuration! \n Please check the reader and try again";

              }
              data = null;
              this.applyIncompatibleReaderState();
              newReader = true;

            }
          }

          if (
            !readers ||
            (readers && readers["selectedReader"] == null || newReader)
          ) {


            if (
              readers &&
              readers["selectedReader"] &&
              this.readerData &&
              Array.isArray(this.readerData) &&
              this.readerData.some(
                (reader) => reader.peripheralId === readers["selectedReader"]["peripheralId"]
              )
            ) {
              // If the selectedReader's peripheralId matches LegacyAny in readerData, assign that reader
              const foundReader = this.readerData.find(
                (reader) =>
                  reader.peripheralId === readers["selectedReader"]["peripheralId"]
              );

              if (foundReader) {
                this.selectedReader = { ...foundReader }; // Assign the entire object
              }
            }

            detectedReaderInfo.readerConnected = !!(
              this.readerData &&
              this.readerData[0] &&
              (
                this.readerData[0].peripheralType !== "LCN9640" ||
                (
                  this.readerData[0].peripheralType === "LCN9640"
                )
              )
            );

            this.appState.setDetectedReaderInfo(detectedReaderInfo);
          }

          detectedReaderInfo.readerConnected = !!(
            this.readerData &&
            this.readerData[0] &&
            (
              this.readerData[0].peripheralType !== "LCN9640" ||
              (
                this.readerData[0].peripheralType === "LCN9640"
              )
            )
          );
          this.appState.setDetectedReaderInfo(detectedReaderInfo);

          const checkDetectedreader=  this.appState.getDetectedReaderInfo();

          if (data && checkDetectedreader.readerConnected) {
            this.hideStatus = true;
            if (this.readerData.length === 1) {
              this.readerName = this.readerData[0];
              this.dataInreader();
            } else {
              if (this.isRetry || !this.isRetry ) {
                const readerSelected = this.appState.getDetectedReaderInfo()?.selectedReader;

                if (readerSelected && this.readerData) {
                  const matchingReader = this.readerData.find(
                    (reader) =>
                      reader.peripheralType === readerSelected.peripheralType &&
                      reader.peripheralId === readerSelected.peripheralId
                  );

                  if (matchingReader) {
                    this.readerName = matchingReader; // Assign the matching reader
                    this.dataInreader();
                  } else {

                    this.readerName = null; // Set to null if no match is found
                  }
                } else {

                  this.readerName = null;
                }
              }


            }
          }

        },
        (error) => {
          this.nextClicked=false;
          this.removeWritingHeader = false;
          this.writingDevicesContainer = false;
          this.customerLoaderAfter = true;
          this.noReader = true;
          this.retryButton = true;
          this.isShowCancelBtn = true;
          this.appState.setReaderDevices(null);
          const detectedReader = {
            readerType: "SimpleSet",
            selectedReader: this.selectedReader,
            readerConnected: false,
          };

          this.appState.setDetectedReaderInfo(detectedReader);
          if (error.status) {
            this.handleErrorCodedError(error);
          } else {
            if (error["Message"]) {
              this.errorMessage = error["Message"];
            } else {
              this.errorMessage = "Please check the connection";
              this.retryButton = true;
              this.isShowCancelBtn = true;
            }
          }
          this.hideStatus = true;
          this.customerLoaderAfter = false;
          this.customerLoader = false;
        }
      );

    //   }
    // });
  }
  dataInreader() {
    this.customerLoaderAfter = true;
    this.envHostName=this.readerBaseUrl;

    // Optimization: Run getDeviceInfo and plugin output fetch in parallel
    const deviceInfo$ = this.getDeviceInfo();
    const pluginOutput$ = this.fetchPluginOutputData();

    forkJoin({ data: deviceInfo$, pluginData: pluginOutput$ })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        ({ data, pluginData }) => {
          // Store pre-fetched plugin data for later use
          if (pluginData) {
            this.preFetchedPluginData = pluginData;
          }

          const configDeviceInfo = this.appState.getConfigurationData();

              const length = Array.isArray(data) ? data.length : 0;
              this.appState.setDeviceDataLength(length);
              this.owpProtectedMultiDevices = false;
              this.readerDeviceData = data[0];
              this.incorrectBoxSize = false;
              let arrayData:LegacyAny[]=[];
                  arrayData =Array(data);
              this.actualDevicesCnt = arrayData[0].length;
              this.deviceNfcIdsList=arrayData[0].map((item)=> item['deviceNfcId']);
              this.outOfCount=this.deviceNfcIdsList.length;
              this.owpProtectedDevices = arrayData[0].filter(item => item.deviceOwpStatus === 'Enabled').length;
              this.totalMatchedDevices = arrayData[0].filter(item => item['deviceMetadata']['device12nc'] === arrayData[0][0]['deviceMetadata']['device12nc']).length;
             if(arrayData[0].length!==Number(this.userBoxSizeValue)){
              this.incorrectBoxSize= true;
              this.customerLoaderAfter = false;
              this.deviceCNtMatched = false;
              this.isShowCancelBtn=true;
             const errorMsg="Number of devices found do not match the given quantity! \n Please adjust the quantity of drivers";
               this.errorMessage = errorMsg
             const errMsg = INCORRECT_DEVICES_FOUND_MSG;
               this.showDCError(errMsg, errorMsg, true);
             }
             else if (arrayData[0].length !== this.totalMatchedDevices) {
               this.customerLoaderAfter = false;
               this.loading = false;
               this.customerLoader = false;
               this.deviceNotMatching = true;
               this.multipleDeviceError = true;
               const errorMsg="All device types should be the same! \n Please check the devices and try again";
               const errMsg="Multiple device types found";
               this.errorMessage = errorMsg
               this.showDCError(errMsg, errorMsg, true);
               this.isShowCancelBtn = true;
             }
              else if (data) {
               this.appState.setSetReaderDEviceInfo(this.readerDeviceData);
               const compatibleFeat = this.checkCompatibleFeat().pipe(shareReplay(1));
               const corruptedNfcSub: BehaviorSubject<string> = new BehaviorSubject(this.deviceNfcIdsList[0]);
                const corruptedNfcSubObs$ = corruptedNfcSub.asObservable();
               let hasShownErrorPopup = false;
                let count = 0;
                      corruptedNfcSubObs$.subscribe((nfcId) => {
                        if (!this.readerName || !this.readerName.peripheralId) {
                          corruptedNfcSub.unsubscribe();
                          this.customerLoaderAfter = false;
                          this.loading = false;
                          this.customerLoader = false;
                          return;
                        }
                        const corruptBit = this.checkCorruptBitByNfcId(nfcId);


                        forkJoin({ compatible: compatibleFeat, corrupt: corruptBit }).subscribe(
                          ({ compatible, corrupt }) => {
                            count++;
                            this.corruptBits = corrupt;
                            //this.featureWithId = results[0];
                            this.featureWithId = JSON.parse(
                              atob(compatible["memoryBank"])
                            );

                            this.appState.setCompatibleFeatureID(this.featureWithId);
                            let isCorrupted = false;
                            const corruptedMemoryBanks: { memoryBankId: string, featureName: string }[] = [];
                            this.corruptBits["memoryBanks"].forEach((element) => {
                              let found = false;
                              for (const feature of this.featureWithId) {
                                if (element["memoryBankId"] === feature["memoryBankId"]) {
                                  isCorrupted = true;
                                  corruptedMemoryBanks.push({
                                    memoryBankId: element["memoryBankId"],
                                    featureName: feature["featureName"]
                                  });
                                  this.corruptFeatures.pushCorruptFeature(feature["featureName"], element["memoryBankId"]);
                                  found = true;
                                }
                              }
                              if (!found) {
                                isCorrupted = true;
                                corruptedMemoryBanks.push({
                                  memoryBankId: element["memoryBankId"],
                                  featureName: "unsupported"
                                });
                              }
                            });

                            if (isCorrupted) {
                              this.corruptedDevicesCount++;
                              this.appState.setCorruptedDevicesCount(this.corruptedDevicesCount);
                            }
                            if (count <= this.totalMatchedDevices) {
                              this.isShowCancelBtn = true;
                              if (this.corruptedDevicesCount > 0) {
                                corruptedMemoryBanks
                                  .map(({ featureName }) => this.normalizeFeatureName(featureName))
                                  .filter(Boolean)
                                  .forEach(name => this.allCorruptedFeaturesSet.add(name));
                                this.corruptedDevices = true;
                                this.isShowCancelBtn = true;// Normalize available features
                                const availableFeaturesSet = new Set(
                                  (this.availFeat.listOfAvailableFeatures || [])
                                    .map(name => this.normalizeFeatureName(name))
                                    .filter(Boolean)
                                );
                                const selectedFeaturesSet = new Set(
                                  (this.uiSignals.getSelectedFeaturesArray() || [])
                                    .map(f => this.normalizeFeatureName((f as { featureName?: string })?.featureName || ""))
                                    .filter(Boolean)
                                );
                                const corruptedFeaturesSet = new Set(
                                  corruptedMemoryBanks
                                    .map(({ featureName }) => this.normalizeFeatureName(featureName))
                                    .filter(Boolean)
                                );
                                const corruptedFeaturesToProcess = processCorruptedSpecialFeatures(
                                  this.allCorruptedFeaturesSet,
                                  availableFeaturesSet,
                                  this.appState
                                );
                                const filteredCorruptedFeatures = Array.from(corruptedFeaturesToProcess)
                                  .filter(name => availableFeaturesSet.has(name))
                                  .sort((a, b) => a.localeCompare(b));
                                const notSupportedCorruptFeatures = Array.from(corruptedFeaturesToProcess)
                                  .filter(name => !availableFeaturesSet.has(name))
                                  .sort((a, b) => a.localeCompare(b));
                                const filteredNotSupportedCorruptFeatures = notSupportedCorruptFeatures;
                                this.corruptFeatures.setFilteredNotSupportedCorruptFeatures(filteredNotSupportedCorruptFeatures);
                                const notSelectedCorruptFeatures = filteredCorruptedFeatures
                                  .filter(name => !selectedFeaturesSet.has(name));
                                if (notSupportedCorruptFeatures.length > 0 && count === this.totalMatchedDevices) {
                                  this.allCorruptFeatureNotSelected = true;
                                  this.nextClicked = false;
                                  this.isShowCancelBtn = true;
                                  const modalRef = this.modalService.open(ReadDefaultValuesPopupComponent, {
                                    backdrop: "static",
                                    keyboard: false,
                                    windowClass: "read-device-modal-comp",
                                    centered: true,
                                    size: "lg",
                                  });
                                  modalRef.componentInstance.data = filteredNotSupportedCorruptFeatures;
                                  this.readerData = null;
                                  this.customerLoader = false;
                                  this.customerLoaderAfter = false;
                                  this.errorMessage = `${this.corruptedDevicesCount} out of ${this.totalMatchedDevices} devices found which have incorrectly configured feature(s)\nSome of these features are not supported in Multione Web.\nPlease use MultiOne Engineering to repair configuration for these features.`;
                                  return;
                                }

                                if (notSelectedCorruptFeatures.length > 0 && count === this.totalMatchedDevices) {
                                  this.allCorruptFeatureNotSelected = true;
                                  this.nextClicked = false;
                                  this.isShowCancelBtn = true;
                                  const modalRef = this.modalService.open(ReadDefaultValuesPopupComponent, {
                                    backdrop: "static",
                                    keyboard: false,
                                    windowClass: "read-device-modal-comp",
                                    centered: true,
                                    size: "lg",
                                  });
                                  modalRef.componentInstance.data = filteredCorruptedFeatures;
                                  this.readerData = null;
                                  this.customerLoader = false;
                                  this.customerLoaderAfter = false;
                                  this.errorMessage = `${this.corruptedDevicesCount} out of ${this.totalMatchedDevices} devices found which have incorrectly configured feature(s): ${filteredCorruptedFeatures}\nPlease reconfigure the box for these features`;
                                  return;
                                }


                              }
                              if (count < this.totalMatchedDevices) {
                                corruptedNfcSub.next(this.deviceNfcIdsList[count]);
                              }
                              else {
                                corruptedNfcSub.unsubscribe();
                                if (!this.allCorruptFeatureNotSelected) {
                                  this.continueConfig();
                                  this.readconfiguredDevices = true;
                                }
                                if (!this.allCorruptFeatureNotSelected && !this.readconfiguredDevices) {
                                  this.continueConfig();
                                } else {
                                  this.customerLoaderAfter = false;
                                  this.loading = false;
                                  this.customerLoader = false;
                                }
                              }
                            }
                            else {
                              if (!this.allCorruptFeatureNotSelected) {
                                this.continueConfig();
                                this.readconfiguredDevices = true;
                              }
                              if (!this.allCorruptFeatureNotSelected && !this.readconfiguredDevices) {
                                this.continueConfig();
                              } else {
                                this.customerLoaderAfter = false;
                                this.loading = false;
                                this.customerLoader = false;
                              }
                              corruptedNfcSub.unsubscribe();
                            }
                          },
                          (err) => {
                            this.isShowCancelBtn = true;
                            count++;
                            if (count === this.deviceNfcIdsList.length) {
                              corruptedNfcSub.unsubscribe();
                              if (this.corruptedDevicesCount > 0) {
                                this.corruptedDevices = true;
                              } else {
                                this.corruptedDevices = false;
                              }
                            } else {
                              corruptedNfcSub.next(this.deviceNfcIdsList[count])

                            }
                            this.feature12NcName = [];
                            this.sendMultiFeatures(this.feature12NcName);
                            this.readerData = false;
                            this.noReader = true;
                            this.customerLoader = false;
                            this.loading = false;
                            this.customerLoaderAfter = false;
                            const myObj = err;
                            this.errorMessage = myObj.Message;
                            if (err.status) {
                              this.isShowCancelBtn = true;
                              this.retryButton = true;
                              this.writingDevicesContainer = false;
                              this.errorCodedDC.forEach((errorCode) => {
                                if (errorCode.includes(err.status)) {
                                  if (err.status === errorCode.split("-")[0]) {
                                    this.errorMessage = errorCode.split("-")[1];
                                    if (err.status === "404.2") {
                                      this.noReader = false;
                                      this.readerPresence=true;
                                      err.message = "Error in finding devices";
                                    }else if(err.status==="404.3"){
                                      this.noReader = false;
                                      this.readerPresence=true;
                                      err.message = INCORRECT_DEVICES_FOUND_MSG;
                                    } else if (err.status === "404.1" || err.status === "412.1") {
                                      err.message = READER_NOT_CONNECTED_MSG;
                                    }


                                    if (!hasShownErrorPopup) {
                                      hasShownErrorPopup = true;
                                      // Show your error popup here
                                      this.showDCError(
                                        err.message,
                                        this.errorMessage,
                                        this.showExtraPopUp
                                      );
                                    }
                                  }
                                }
                              });
                            }
                            else {
                              if (
                                this.errorMessage ===
                                "An error occurred while retrieving the corrupt Memory Banks! \r\n Please check the Device or Peripheral ID and try again!"
                              ) {
                                this.errorMessage =
                                  "An error occured while retrieving the corrupt data. Please check the Device or Peripheral ID and try again!";
                                this.retryButton = true;
                                this.isShowCancelBtn = true;
                              }
                            }
                          }
                        );
                       });
              }
            },
            (err) => {

              if(err.description==="Expected devices not found"){

                const tempUpdate = this.appState.getConfigurationData();

                this.readerDeviceData = {deviceMetadata : tempUpdate}

                let arrayData:LegacyAny[]=[];
                arrayData =Array(err);

                const actualDevices = arrayData[0].deviceNfcIds.length
                if(actualDevices!==Number(this.userBoxSizeValue)){
                   this.incorrectBoxSize= true;
                 this.customerLoaderAfter = false;
                this.deviceCNtMatched = false;
                  const errorMsg="Number of devices found do not match the given quantity! \n Please adjust the quantity of drivers";
                  const errMsg = INCORRECT_DEVICES_FOUND_MSG;
                  this.errorMessage = errorMsg
                  this.showDCError(errMsg, errorMsg, true);
                  }
this.isShowCancelBtn=true;
                  this.outOfCount = actualDevices
                  this.actualDevicesCnt = actualDevices
              }
         else{
              this.retryButton = true;
              this.readerData = false;
              this.isShowCancelBtn = true;
              this.removeWritingHeader = false;
              this.writingDevicesContainer = false;
              this.noReader = true;
              this.customerLoader = false;
              this.loading = false;
              this.customerLoaderAfter = false;
              const myObj = err;
              this.errorMessage = myObj.Message;
                if (err.status) {
                  this.handleMultiDeviceErrorCodedError(err);
                }

              }
            this.isShowCancelBtn = true;
            }
          );

  }

   normalizeFeatureName(rawName: string): string | null {
    rawName = rawName.trim().toLowerCase();
    for (const { name, pattern, exclude } of FEATURE_PATTERNS) {
      if (exclude && exclude.test(rawName)) continue;
      if (pattern.test(rawName)) {
        const normalized = FEATURE_NORMALIZATION[name.toLowerCase()];
        return normalized || name;
      }
    }
    return FEATURE_NORMALIZATION[rawName] || null;
  }

  continueConfig(){
    this.removeSuccessText = true;
    this.hideStatus = true;
    const configDeviceInfo = this.appState.getConfigurationData();
    this.isNormalFlow = this.appState.getNormalFlow();
    let checkDeviceSoftware;
    const compareFirmware = this.appState.getCompareFirmwareNoLatest();
    if (compareFirmware) {
      checkDeviceSoftware = compareFirmware;
      if (checkDeviceSoftware.length > 3) {
        checkDeviceSoftware = checkDeviceSoftware.slice(0, -2);
      }
    }

    if (
      configDeviceInfo &&
      configDeviceInfo["device12nc"] ==
        this.readerDeviceData.deviceMetadata["device12nc"] &&
      checkDeviceSoftware ==
        this.readerDeviceData.deviceMetadata["deviceSwVersion"]
    ) {
      this.customerLoader = false;
      this.hideStatus = true;
      this.removeSuccessText = false;
      this.removeWritingHeader = true;
      this.writingDevicesContainer = true;
      this.deviceCNtMatched = true;
      this.customerLoaderAfter = false;


      this.nextOnValidDevices();
    } else if (this.isNormalFlow) {
     /*  this.readerData = false;
      this.noReader = true;
      this.removeWritingHeader = false;
      this.writingDevicesContainer = false;
      this.customerLoader = false;
      this.loading = false;
      this.customerLoaderAfter = false;
      this.errorMessage =
        "This device is not matching with the connected device. Please choose another device."; */
        this.loading = false;
        this.customerLoader = false;
      this.deviceNotMatching=true
      const errorMsg = "Type of devices found does not match type of device in configuration\nPlease retry with another device type";
      const errMsg = "Incorrect device type found"
      this.errorMessage = errorMsg
      this.differentDeviceError=true;
      this.showDCError(errMsg, errorMsg, true);
        this.customerLoader = false;
        this.customerLoaderAfter = false;
    }
  }



  getMemoreyBankList() {
    const compatibleFeat = this.checkCompatibleFeat().pipe(shareReplay(1));

          this.getMemoryBank().subscribe(
            (data) => {
              if (data) {
                const corruptBit = this.checkCorruptBit();
                forkJoin({ compatible: compatibleFeat, corrupt: corruptBit }).subscribe(
                  ({ compatible, corrupt }) => {
                    this.corruptBits = corrupt;
                    this.featureWithId = JSON.parse(
                      atob(compatible["memoryBank"])
                    );

                    this.appState.setCompatibleFeatureID(this.featureWithId);
                    if (this.corruptBits && Array.isArray(this.corruptBits["memoryBanks"])) {
                      this.corruptBits["memoryBanks"].forEach((element) => {
                        for (let i = 0; i < this.featureWithId.length; i++) {
                          if (element["memoryBankId"] === this.featureWithId[i]["memoryBankId"]) {
                            this.corrupt.push(this.featureWithId[i]["featureName"]);
                          }
                        }
                      });
                    }

                    const isWriting = this.appState.getIsWriting();
                    if (!isWriting) {
                      this.getConfiguration();
                    } else {
                      this.getImportPayLoad(200);
                    }
                  },
                  (err) => {
                    this.feature12NcName = [];
                    this.sendMultiFeatures(this.feature12NcName);
                    this.readerData = false;
                    this.noReader = true;
                    this.customerLoader = false;
                    this.loading = false;
                    this.customerLoaderAfter = false;
                    const myObj = err;
                    this.errorMessage = myObj.Message;
                    if (err.status) {
                      this.handleMultiDeviceErrorCodedError(err);
                    }
                    else {
                      if (
                        this.errorMessage ===
                        "An error occurred while retrieving the corrupt Memory Banks! \r\n Please check the Device or Peripheral ID and try again!"
                      ) {
                        this.errorMessage =
                          "An error occured while retrieving the corrupt data. Please check the Device or Peripheral ID and try again!";
                        this.retryButton = true;
                        this.isShowCancelBtn = true;
                      }
                    }
                  }
                );
              }
            },
            (err) => {
              this.feature12NcName = [];
              this.sendMultiFeatures(this.feature12NcName);
              this.readerData = false;
              this.noReader = true;
              this.customerLoader = false;
              this.loading = false;
              this.customerLoaderAfter = false;
              const myObj = err;
              this.errorMessage = myObj.Message;
              if (err.status) {
                this.handleMultiDeviceErrorCodedError(err);
              }
 else {
                if (
                  this.errorMessage ===
                  "An error occurred while retrieving the list of supported Memory Banks! \r\n Please check the Device or Peripheral ID and try again!"
                ) {
                  this.errorMessage =
                    "An error occured while retrieving the data. Please check the Device or Peripheral ID and try again!";
                  this.retryButton = true;
                  this.isShowCancelBtn = true;
                }
              }
              this.isShowCancelBtn = true;
            }
          );
  }



  cancel() {
    this.appState.setNormalFlow(false);
    this.deviceConfig.setUserInputBoxValue(null);
    this.route.navigate(["/featureLanding"]);
    this.showRetryOwpButton = false;
    this.changedDEVICE = false;
    this.owp.sendOwpPasswordSelected(false);
    //this.uiSignals.removeModes("invalid");
    this.uiSignals.modalClose("");
    this.httpClient.clearConfigCache();
    this.uiSignals.readerInfo("");
    this.unsubscribe.unsubscribe();
    this.sendMultiFeatures("");
    this.corruptFeatures.sendCorruptFeat("");
    this.corruptFeatures.sendNonCorrupt("");
    this.corruptFeatures.redFailedFeatures("");
  }

  getConfiguration() {
          this.configurationAPI(this.readerDeviceData.deviceMetadata).subscribe(
            (data) => {
              if (data) {
                this.hideStatus = true;
                this.startConfiguration = data;
                this.appState.setReaderConfigurationData(this.startConfiguration);
                this.getFeaturePayload();
              }
            },
            (err) => {
              this.feature12NcName = [];
              this.sendMultiFeatures(this.feature12NcName);
              this.readerData = false;
              this.noReader = true;
              this.customerLoader = false;
              this.loading = false;
              this.customerLoaderAfter = false;
              const myObj = err;
              this.errorMessage = myObj.message;
              //this.specialErrorNoDatabase = true;
              if (this.errorMessage === "Device type Not Exist.") {
                const deviceInfoUnAvailable =
                  this.readerDeviceData.deviceMetadata;
                // this.errorMessage = 'Device is not available in our database. So we cannot read or write, please choose another device';
                 this.deviceNotMatching = true;
                this.multipleDeviceError = true;
                const errorMsg="All device types should be the same! \n Please check the devices and try again";
                const errMsg="Multiple device types found";
                this.errorMessage = errorMsg
                this.showDCError(errMsg, errorMsg, true);
                this.isShowCancelBtn = true;
              }
              this.isShowCancelBtn = true;
            }
          );
      //   }
      // });
  }


  getFeaturePayload() {
    const supportedMB: LegacyAny[] = [];
    this.feature12NcName.forEach((featureMBName) => {
      switch (featureMBName) {
        case "luminfoformat4-":
          supportedMB.push({
            memoryBankId: "52-0",
          });
          supportedMB.push({
            memoryBankId: "1-0",
          });
          break;
        case "luminfoformat5-":
          supportedMB.push({
            memoryBankId: "52-0",
          });
          supportedMB.push({
            memoryBankId: "1-0",
          });
          break;
        case "luminfoformat3-":
          supportedMB.push({
            memoryBankId: "52-0",
          });
          supportedMB.push({
            memoryBankId: "1-0",
          });
          break;
        case "luminfoformat0-":
          supportedMB.push({
            memoryBankId: "52-0",
          });
          supportedMB.push({
            memoryBankId: "1-0",
          });
          break;
        case "clo-":
          supportedMB.push({
            memoryBankId: "14-0",
          });
          break;
        case "ast-":
          supportedMB.push({
            memoryBankId: "29-0",
          });
          break;
        case "srpsu-":
          supportedMB.push({
            memoryBankId: "35-0",
          });
          break;
        case "dalipsu-":
          if(!this.feature12NcName.includes('srpsu-')){
            supportedMB.push({
              memoryBankId: "35-0",
            });
          }
          break;
        case "alo-":
          supportedMB.push({
            memoryBankId: "37-0",
          });
          supportedMB.push({
            memoryBankId: "73-0",
          });
          break;
        case "aoc-":
          supportedMB.push({
            memoryBankId: "114-0",
          });
          supportedMB.push({
            memoryBankId: "149-0",
          });

          break;
        case "clolite-":
          supportedMB.push({
            memoryBankId: "14-0",
          });
          break;
        case "ztv-":
          supportedMB.push({
            memoryBankId: "19-0",
          });
          break;
        case "dynadimmer-":
          supportedMB.push({
            memoryBankId: "13-0",
          });
          break;
        case "lineswitch-":
          supportedMB.push({
            memoryBankId: "15-0",
          });
          break;
        case "ampdim-":
          supportedMB.push({
            memoryBankId: "18-0",
          });
          break;
        case "dcemergency-":
          supportedMB.push({
            memoryBankId: "75-0",
          });
          break;
        case "dtl-":
          supportedMB.push({
            memoryBankId: "74-0",
          });
          break;
        case "mtp-":
          supportedMB.push({
            memoryBankId: "113-0",
          });
          break;
        case "mindimlevel-":
          supportedMB.push({
            memoryBankId: "30-0",
          });
          break;
        case "codedmains-":
          supportedMB.push({
            memoryBankId: "36-0",
          });
          break;
        case "touchdim-":
          supportedMB.push({
            memoryBankId: "27-0",
          });
          break;
        case "ztvoutput-":
          supportedMB.push({
            memoryBankId: "158-0",
          });
          break;
        case "rso-":
          supportedMB.push({
            memoryBankId: "156-0",
          });
          break;
        case "lip-":
          supportedMB.push({
            memoryBankId: "162-0",
          });
          break;
        case "corridor-":
          supportedMB.push({
            memoryBankId: "16-0",
          });
        case "diia253maintenance-":
          supportedMB.push({
            memoryBankId: "207-0",
          });
          break;
        case "owp-":
          supportedMB.push({
            memoryBankId: "43-0",
          });
          supportedMB.push({
            memoryBankId: "44-0",
          });
          supportedMB.push({
            memoryBankId: "193-6",
          });
          break;
        case "flextune-":
          supportedMB.push({
            memoryBankId: "121-0",
          });
          supportedMB.push({
            memoryBankId: "119-0",
          });
          break;
        case "multiconfigmode-":
          supportedMB.push({
            memoryBankId: "161-0",
          });
          break;
        default:
          break;
      }
    });
    const allPayResp = {
      memorybankIds:
      //this.specificMemoryBanksList
      supportedMB,
    };
    this.unsubscribe.next(undefined);
    //this.httpClient.apiCall('post',this.readerBaseUrl+this.payLoadUrl.replace('{peripheralId}',this.readerName['peripheralType']).replace('{deviceNfcId}', this.readerDeviceData['deviceNfcId']),allPayResp)
    this.httpClient
      .apiCall(
        "post",
        this.readerBaseUrl +
        this.payLoadUrl
          .replace("{peripheralId}", this.readerName["peripheralId"])
          .replace(
            "{deviceNfcId}",
            this.readerDeviceData["deviceNfcId"]
          ),
        allPayResp
      )
      .subscribe(
        (resp) => {
          this.mem = resp;
          this.getImportPayLoad(200);
        },
        (err) => {
          this.feature12NcName = [];
          this.availFeat.sendFeatures(this.feature12NcName);
          this.writingDevicesContainer = false;
          this.readerData = false;
          this.noReader = true;
          this.customerLoader = false;
          this.loading = false;
          this.customerLoaderAfter = false;
          const myObj = err;
          this.errorMessage = myObj.Message;
          if (err.status) {
            this.handleErrorCodedError(err, true);
          } else {
            if (
              this.errorMessage ===
              "An error occurred while returning the memory bank properties! \r\n Please check the Device or Peripheral ID and try again!"
            ) {
              this.errorMessage =
                "An error occurred while returning the properties!  Please check the Device or Peripheral ID and try again!";
              this.retryButton = true;
            }
          }
          this.isShowCancelBtn = true;
        }
      );

  }


  getImportPayLoad(statusCode: number) {
    setResultFeatures(this.appState,statusCode,this.uiSignals.getSelectedFeaturesArray(),this.corrupt,this.deviceInfo);
    this.customerLoaderAfter = false;
  }

  // Helper method to fetch plugin output data for parallel execution
  fetchPluginOutputData(): Observable<LegacyAny> {
    const configuration = this.appState.getConfigurationData();
    if (!configuration || !configuration["configurationID"]) {
      return of(null);
    }

    const configId = configuration["configurationID"];

    // Check if data exists in service cache
    if (this.httpClient.hasCachedConfigData(configId)) {
      const cachedData = this.httpClient.getCachedConfigData(configId);
      return of(cachedData);
    }

    // If not in cache, make API call
    const writngUrl = this.url + this.writingURLViaPlugin;
    return this.apiCall(
      "get",
      writngUrl.replace("{configurationId}", configId)
    ).pipe(
      tap((data) => {
        // Store in service cache on successful fetch
        if (data) {
          this.httpClient.setCachedConfigData(configId, data);
        }
      }),
      catchError(() => of(null))
    );
  }

  generatePluginOutput() {
    const allNfcIds = this.deviceNfcIdsList.slice();
    const configuration = this.appState.getConfigurationData();
    const configId = configuration["configurationID"];

    // Check if data exists in service cache
    if (this.httpClient.hasCachedConfigData(configId)) {
      const cachedData = this.httpClient.getCachedConfigData(configId);
      this.mem = cachedData;
      this.processDevicesSequentially(cachedData, allNfcIds, 0);
      return;
    }

    // If not in cache, make API call
    const writngUrl = this.url + this.writingURLViaPlugin;

    this.httpClient
      .apiCall(
        "get",
        writngUrl.replace("{configurationId}", configId)
      )
      .subscribe(
        (data) => {
          if (data) {
            // Store in service cache
            this.httpClient.setCachedConfigData(configId, data);
            this.mem = data;
            this.processDevicesSequentially(data, allNfcIds, 0);
          }
        },
        (err) => {
          this.handleGeneratePluginError(err);
        }
      );
  }


  openOwpPasswordPopup() {
    this.showRetryOwpButton = true;
    this.isShowCancelBtn = true;
    this.changedDEVICE = false;
    this.owp.sendOwpPasswordSelected(true);
    const modalRef = this.modalService.open(OwpPasswordComponent, {
      keyboard: false,
      centered: true,
      windowClass: "owp-popup-style",
      size: "xs",
      backdrop: 'static'
    });

    modalRef.componentInstance.sendOwpPwd.subscribe((pwd) => {
      this.showRetryOwpButton = false;
      this.isShowCancelBtn = false;
      const values = Object.values(pwd);
      if (values.every(v => v !== null)) {
        this.owp.sendOwpAccessPwd(values);
      }
      this.owpError = false;
      const configuration = this.appState.getConfigurationData();
      const writngUrl = this.url + this.writingURLViaPlugin;
      this.apiCall(
        "get",
        writngUrl.replace("{configurationId}", configuration["configurationID"])
      ).subscribe((data) => {
        if (data) {
          this.mem = data;
          this.initialCount = 0;
          // Store the failed IDs to process
          const idsToRetry = [...this.failedOwpNfcIds];
          // Clear the failed IDs before retry
          this.failedOwpNfcIds = [];
          this.processDevicesSequentially(data, idsToRetry, 0);
        }
      });
    });
  }

  nextOnValidDevices(){

    this.deviceCNtMatched = false;
    this.configConnectedDevices = true;
    this.incorrectBoxSize = false;
    this.owpProtectedMultiDevices = false;
    this.corruptedDevices = false;
    this.deviceNotMatching = false;
    this.customerLoaderAfter = true;
    this.showNextSuccessWriteBtn = false;

    // Use pre-fetched plugin data if available, otherwise fetch it now
    if (this.preFetchedPluginData) {
      this.processPreFetchedPluginData();
    } else {
      this.generatePluginOutput();
    }


  }

  // Process pre-fetched plugin data
  processPreFetchedPluginData() {
    const allNfcIds = this.deviceNfcIdsList.slice();
    this.mem = this.preFetchedPluginData;
    this.processDevicesSequentially(this.preFetchedPluginData, allNfcIds, 0);
  }

  private processDevicesSequentially(data: LegacyAny, allNfcIds: string[], index: number) {
    if (index >= allNfcIds.length) {
      // All drivers processed
      if (this.failedOwpNfcIds.length > 0) {
        // Some devices failed with OWP error
        this.isShowCancelBtn = true;
        this.hideStatus = true;
        this.readerData = true;
        this.writingDevicesContainer = false;

        this.customerLoader = false;
        this.loading = false;
        this.customerLoaderAfter = false;

        if (this.changedDEVICE) {
          this.owpError = false;
          this.retryButton = true;
          this.noReader = false;
          this.errorMessage = "Devices have been changed or disconnected! \n Please reconnect the original devices and try again";
          this.showDCError("Device(s) not found", this.errorMessage, true);
          return;
        }

        if (this.noReader) {
          this.owpError = false;
          this.isDeviceConnected = false;
          this.retryButton = true;
          this.errorMessage = "Please check the reader and try again";
          this.showDCError(READER_NOT_CONNECTED_MSG, this.errorMessage, true);
          return;
        }

        this.owpError = true;
        this.retryOwpPassword = true;
        this.showRetryOwpButton = true;
        this.noReader = false;
        const errorHeading = "Incorrect OWP password provided";
        if (this.failedOwpNfcIds.length === allNfcIds.length) {
          this.errorMessage = "Some features are OWP protected \n Please provide the correct OEM Write Protection password which currently locks the driver";
        } else {
          this.errorMessage = `${(allNfcIds.length - this.failedOwpNfcIds.length)} devices have been configured. \n${this.failedOwpNfcIds.length} out of ${allNfcIds.length} devices have a different password! \nPlease type the correct password for those drivers`;
        }
        this.showDCError(errorHeading, this.errorMessage, true);
        return;
      }

      // All drivers processed successfully
      this.writingDevicesContainer = true;
      this.readerData = true;
      this.noReader = false;
      this.customerLoader = false;
      this.loading = false;
      this.customerLoaderAfter = false;
      this.finalizeConfiguration();
      return;
    }

    const nfcId = allNfcIds[index];

    // Write to device first
    this.writeSingleDevice(data, nfcId).subscribe({
      next: (writeResult) => {
        // Check if PWM device data exists in the response
        let parsedData: LegacyAny = writeResult;

        if (writeResult instanceof ArrayBuffer) {
          try {
            const decoder = new TextDecoder("utf-8");
            const jsonString = decoder.decode(new Uint8Array(writeResult));
            parsedData = JSON.parse(jsonString);
          } catch (e) {
            parsedData = {};
          }
        }

        // If PWM device data exists, process it
        if (parsedData?.pwmDevice?.readMemoryBanks) {
          this.processPWMDevice(parsedData, nfcId).subscribe({
            next: () => {
              // PWM processing complete, move to next device
              this.processDevicesSequentially(data, allNfcIds, index + 1);
            },
            error: (error) => {
              // Continue with next device even if PWM fails
              this.processDevicesSequentially(data, allNfcIds, index + 1);
            }
          });
        } else {
          // No PWM device data, move to next device
          this.processDevicesSequentially(data, allNfcIds, index + 1);
        }
      },
      error: (error) => {
        // Continue processing next device regardless of error
        this.processDevicesSequentially(data, allNfcIds, index + 1);
      }
    });
  }

  private writeSingleDevice(data: LegacyAny, nfcId: string): Observable<LegacyAny> {
    const detectedreader = this.appState.getDetectedReaderInfo();
    const readerName = detectedreader.selectedReader;
    const startConfiguration = this.appState.getConfigurationData();
    this.feature12NcName["allFeature"] = startConfiguration["selectedFeaturesInfo"];
    this.sendMultiFeatures(this.feature12NcName["allFeature"]);
    this.writingURL = this.readerBaseUrl + this.writingInDeviceURL;
    const writingObj = data;

    return new Observable<LegacyAny>((observer) => {
      this.putApi(
          "put",
          this.writingURL
            .replace("{peripheralId}", readerName["peripheralId"])
            .replace("{deviceNfcId}", nfcId),
          writingObj
        )
        .subscribe(
          (response) => {
            this.initialCount++;
            observer.next(response);
            observer.complete();
          },
          (err) => {
            if (
              err.status === "401"
            ) {
              this.failedOwpNfcIds.push(nfcId);
            } else if (err.status === "412.1" || err.status === "422.2" || err.status === "500") {

              if (err.status === "412.1") {
                this.failedOwpNfcIds.push(nfcId);
                this.noReader = true;
              } else {
                this.failedOwpNfcIds.push(nfcId);
                this.changedDEVICE = true;
              }
            }
            this.initialCount++;
            observer.error(err);
          }
        );
    });
  }

  private processPWMDevice(parsedData: LegacyAny, nfcId: string): Observable<LegacyAny> {
    return new Observable<LegacyAny>((observer) => {
      const memorybankIds = parsedData.pwmDevice.readMemoryBanks.map(mb => ({
        memoryBankId: mb.memoryBankId
      }));

      this.getFormattedMemoryBanks(memorybankIds, nfcId).subscribe({
        next: (requiredCurrent) => {
          const formattedProperties = requiredCurrent.formattedProperties;

          const aocBank = formattedProperties.find(
            prop => prop.memoryBankId === "114-0" && prop.memoryBankName === "AOC"
          );
          const currentValue = aocBank?.parameters?.current;

          const aloBank = formattedProperties.find(
            prop => prop.memoryBankId === "73-0" && prop.memoryBankName === "ALO"
          );
          const percentageValue = aloBank?.parameters?.enabled === true
            ? aloBank.parameters.percentage
            : 100;

          const calculatedCurrent = (currentValue * percentageValue) / 100;
          const pwmValue = this.calculatePWM(
            parsedData.pwmDevice.aocCurrent2PwmConversionTable,
            calculatedCurrent
          );

          // Write the PWM value back to the device
          const pwmProperty = parsedData.pwmDevice.writeMemoryBanks[0];
          if (!pwmProperty.parameters) {
            pwmProperty.parameters = {};
          }
          pwmProperty.parameters.enabled = aocBank.parameters.enabled;
          pwmProperty.parameters.pulseWidth = Math.floor(pwmValue);

          requiredCurrent.iv = this.mem.iv;
          requiredCurrent.metadata = this.mem.metadata;
          requiredCurrent.owp = this.mem.owp;
          requiredCurrent.formattedProperties.push(pwmProperty);
          requiredCurrent.formattedProperties = requiredCurrent.formattedProperties.filter(
            prop => prop !== aloBank
          );

          this.writePwmToDevice(requiredCurrent, nfcId).subscribe({
            next: () => {
              observer.next(undefined);
              observer.complete();
            },
            error: (error) => {
              observer.error(error);
            }
          });
        },
        error: (error) => {
          observer.error(error);
        }
      });
    });
  }

  private finalizeConfiguration() {
    this.appState.setSaveSetData(null);
    this.removeWritingHeader = false;
    this.removeSuccessText = false;
    this.readerData = this.appState.getReaderInfo();
    this.readerName = this.readerData[0];
    this.readerDeviceData = this.appState.getSetReaderDEviceInfo();

    if (this.appState.getCompatibleFeatureID()) {
      this.featureWithId = this.appState.getCompatibleFeatureID();
      this.getImportPayLoad(200);
    } else {
      const isWriting = this.appState.getIsWriting();
      if (!isWriting) {
        this.getConfiguration();
      } else {
        this.getImportPayLoad(400);
      }
    }
  }




  getReaderList() {
    return this.apiCall("get", this.readerBaseUrl + this.readerListUrl);
  }

  getDeviceInfo() {
      if (this.readerName["peripheralType"] === "LCN9640") {
      this.deviceInfoUrl = `/peripheral/v1/nfc/{peripheralId}/devices/${this.userBoxSizeValue}?refresh=true`;
    } else {
      this.deviceInfoUrl = "/peripheral/v1/nfc/{peripheralId}/devices?refresh=true";
    }

    return this.apiCall(
      "get",
      this.readerBaseUrl +
        this.deviceInfoUrl.replace(
          "{peripheralId}",
          this.readerName["peripheralId"]
        )
    );
  }

  getMemoryBank() {
    return this.apiCall(
      "get",
      this.readerBaseUrl +
        this.memoryBankUrl
          .replace("{peripheralId}", this.readerName["peripheralId"])
          .replace("{deviceNfcId}",this.readerDeviceData["deviceNfcId"])
    );
  }

  getMemoryBankByNfcID(deviceNfcId:LegacyAny) {
    return this.apiCall(
      "get",
      this.readerBaseUrl +
        this.memoryBankUrl
          .replace("{peripheralId}", this.readerName["peripheralId"])
          .replace("{deviceNfcId}", deviceNfcId)
    );
  }


  checkCompatibleFeat() {
    return of(environment.commonMemoryBank);
  }

  checkCorruptBit() {
    return this.apiCall(
      "get",
      this.readerBaseUrl +
        this.corruptBitUrl
          .replace("{peripheralId}", this.readerName["peripheralId"])
          .replace("{deviceNfcId}", this.readerDeviceData["deviceNfcId"])
    );
  }

  checkCorruptBitByNfcId(deviceNfcId:LegacyAny) {
    if (!this.readerName || !this.readerName.peripheralId) {
      return of(null);
    }
    return this.apiCall(
      "get",
      this.readerBaseUrl +
        this.corruptBitUrl
          .replace("{peripheralId}", this.readerName["peripheralId"])
          .replace("{deviceNfcId}", deviceNfcId)
    );
  }

  configurationAPI(deviceInfo) {
    const mockDevice = {
      device12nc: deviceInfo.device12nc,
      deviceName: deviceInfo.deviceName,
      softwareVersion: deviceInfo.deviceSwVersion,
    };
    return this.httpClient.getStartConfiguration(
      mockDevice,
      this.startConfigurationURL
    );
  }



  nextSuccessMultiWrite(){
    this.incorrectBoxSize = false;
    this.deviceCNtMatched = false;
    this.owpProtectedMultiDevices = false;
    this.deviceNotMatching = false;
    this.corruptedDevices = false;
    this.mtpExtras.sendShowNextSuccessBtnMulti(false);
    this.showNextSuccessWriteBtn = false;
    this.httpClient.clearConfigCache();
    const modalRef = this.modalService.open(ConfigureDeviceModalInputComponent, {
      windowClass: "select-feature-modal",
      backdropClass: "customBackdrop",
    });
  }

  retry() {
    this.nextClicked=true;
    if(this.owpError) {
      this.owp.sendOwpPasswordSelected(true);
      this.httpClient.clearConfigCache();
      const modalRef = this.modalService.open(OwpPasswordComponent, {
        keyboard: false,
        centered: true,
        windowClass: "owp-popup-style",
        size: "xs",
        backdrop: 'static'
      });

      modalRef.componentInstance.sendOwpPwd.subscribe((pwd) => {
        const values = Object.values(pwd);
        if (values.every(v => v !== null)) {
          this.owp.sendOwpAccessPwd(values);
        }
        this.availFeat.modalConfigurationData("readDevice");

        const modalRef = this.modalService.open(ReadDeviceMultiDriverComponent, {
          windowClass: "select-feature-modal",
          backdropClass: "customBackdrop",
          backdrop: 'static',
          keyboard: false
        });
        modalRef.componentInstance.isRetry = true;
      });
    } else if (this.isWritingRetryCheck) {
      //  this.cancel();
      this.uiSignals.modalClose("");
      this.uiSignals.readerInfo("");
      this.unsubscribe.unsubscribe();
      this.sendMultiFeatures("");
      this.corruptFeatures.sendCorruptFeat("");
      this.corruptFeatures.sendNonCorrupt("");
      this.corruptFeatures.redFailedFeatures("");

      this.retryClicked = true;

      this.availFeat.modalConfigurationData("readDevice");

      const modalRef = this.modalService.open(ReadDeviceMultiDriverComponent, {
        windowClass: "select-feature-modal",
        backdropClass: "customBackdrop",
        backdrop: 'static',
        keyboard: false
      });
      modalRef.componentInstance.isRetry = true;
    } else {
      this.cancel();
      this.uiSignals.modalClose("");
      this.uiSignals.readerInfo("");
      this.unsubscribe.unsubscribe();
      this.sendMultiFeatures("");
      this.corruptFeatures.sendCorruptFeat("");
      this.corruptFeatures.sendNonCorrupt("");
      this.corruptFeatures.redFailedFeatures("");
      this.httpClient.clearConfigCache();
      this.retryClicked = true;
      this.appState.setNormalFlow(false);
      this.appState.setCCTBoolen(null);
      this.appState.setSaveReadValue(null);
      this.appState.setResultFeatures(null);
      this.appState.removeCorruptMemoryBankId();
      this.appState.setSupportedFeatures(null);
      this.appState.setConfigurationData(null);
      this.appState.setReaderDeviceFullInfo(null);
      this.uiSignals.removeModes("invalid");
      this.appState.setSaveSetData(null);

      this.appState.setIsWriting(false);
      this.availFeat.modalConfigurationData("readDevice");

      const modalRef = this.modalService.open(ReadDeviceMultiDriverComponent, {
        windowClass: "select-feature-modal",
        backdropClass: "customBackdrop",
        backdrop: 'static',
        keyboard: false
      });
      modalRef.componentInstance.isRetry = true;
    }
  }

  retryConfigure() {
    this.newReaderInfo();
  }

  private handleGeneratePluginError(err: LegacyAny) {
    this.isShowCancelBtn = true;
    this.readerData = false;
    this.writingDevicesContainer = false;
    this.noReader = true;
    this.customerLoader = false;
    this.loading = false;
    this.customerLoaderAfter = false;
    const myObj = err;
    this.errorMessage = myObj.message;

    if (err.status) {
      this.handleMultiDeviceErrorCodedError(err);
    } else {
      const modalRef = this.modalService.open(ErrorComponent, {
        keyboard: false,
        centered: true,
        windowClass: "error-style, error-style1",
        backdrop: 'static'
      });
      modalRef.componentInstance.errorName = err["message"];
      modalRef.componentInstance.errorDescription = err["description"];
    }
  }

  getFormattedMemoryBanks(memorybankIds, nfcId): Observable<LegacyAny> {
    const detectedreader = this.appState.getDetectedReaderInfo();
    const readerName = detectedreader.selectedReader;


    this.apiListResponse = [];
    return new Observable<LegacyAny>((observer) => {
            this.writingURL = this.readerBaseUrl + this.formattedMemoryBankUrl;
            const allPayResp = {
              memorybankIds: memorybankIds,
            };

            return this.apiCall(
                "post",
                this.writingURL
                  .replace("{peripheralId}", readerName["peripheralId"])
                  .replace("{deviceNfcId}", nfcId),
                allPayResp
              )
              .subscribe(
                (result) => {
                  observer.next(result);
                  observer.complete();
                },
                (error) => {
                  if (error.status === "412.1" || error.status === "422.2" || error.status === "500" || error.status ==="405") {

                    if (error.status === "412.1") {
                      this.failedOwpNfcIds.push(nfcId);
                      this.noReader = true;
                    } else {
                      this.failedOwpNfcIds.push(nfcId);
                      this.changedDEVICE = true;
                    }
                  }
                  this.initialCount++;

                  observer.error(error);
                }
              );
    });
  }

  writePwmToDevice(pwmProperty, nfcId): Observable<LegacyAny> {
    const detectedreader = this.appState.getDetectedReaderInfo();
    const readerName = detectedreader.selectedReader;


    this.apiListResponse = [];
    return new Observable<LegacyAny>((observer) => {
            this.writingURL = this.readerBaseUrl + this.formattedMemoryBankUrl;

            this.putApi(
              "put",
              this.writingURL
                .replace("{peripheralId}", readerName["peripheralId"])
                .replace("{deviceNfcId}", nfcId),
                pwmProperty
              )
              .subscribe(
                (result) => {
                  observer.next(result);
                  observer.complete();
                },
                (error) => {

                  if (error.status === "422.2" || error.status === "412.1" || error.status === "405" || error.status ==="500") {

                    if (error.status === "412.1") {
                      this.noReader = true;
                      this.failedOwpNfcIds.push(nfcId);
                    } else {
                      this.changedDEVICE = true;
                      this.failedOwpNfcIds.push(nfcId);
                    }
                  }
                  this.initialCount++;
                  observer.error(error);
                }
              );
    });
  }

  calculatePWM(conversionTable, targetCurrent) {
    if (!Array.isArray(conversionTable) || conversionTable.length === 0) return null;

    // Filter out entries without aocCurrent or pulseWidth
    const filtered = conversionTable.filter(
      entry => entry && typeof entry.aocCurrent === 'number' && typeof entry.pulseWidth === 'number'
    );
    if (filtered.length === 0) return null;

    const sorted = filtered.slice().sort((a, b) => a.aocCurrent - b.aocCurrent);

    if (targetCurrent <= sorted[0].aocCurrent) return sorted[0].pulseWidth;
    if (targetCurrent >= sorted[sorted.length - 1].aocCurrent) return sorted[sorted.length - 1].pulseWidth;

    for (let i = 0; i < sorted.length - 1; i++) {
      const x0 = sorted[i].aocCurrent;
      const y0 = sorted[i].pulseWidth;
      const x1 = sorted[i + 1].aocCurrent;
      const y1 = sorted[i + 1].pulseWidth;

      if (targetCurrent >= x0 && targetCurrent <= x1) {
        return y0 + ((y1 - y0) * (targetCurrent - x0)) / (x1 - x0);
      }
    }
    return null;
  }


  ngOnDestroy() {
    this.uiSignals.modalClose("");
    this.uiSignals.readerInfo("");
    this.unsubscribe.unsubscribe();
    this.appState.removeCorruptMemoryBankId();
    this.sendMultiFeatures("");
    this.corruptFeatures.sendCorruptFeat("");
    this.corruptFeatures.sendNonCorrupt("");
    this.corruptFeatures.setFilteredNotSupportedCorruptFeatures(null);
    this.corruptFeatures.redFailedFeatures("");
    this.showNextSuccessWriteBtn = false;
    if(this.getShowNextMultiSuccessBtnSub){
     this.getShowNextMultiSuccessBtnSub.unsubscribe();
    };
    this.deviceCNtMatched = false;
  }
}
